var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./SubmissionForm.jinja');
require('./SubmissionForm.less');
require('./SubmissionFormElement.less');


var SubmissionFormCategory = require('submissions/components/SubmissionForm/SubmissionFormCategory');
var SubmissionFormInformationTv = require('submissions/components/SubmissionForm/SubmissionFormInformationTv');
var SubmissionFormEpisodes = require('submissions/components/SubmissionForm/SubmissionFormEpisodes');
var SubmissionFormInformationFilm = require('submissions/components/SubmissionForm/SubmissionFormInformationFilm');
var SubmissionFormMembers = require('submissions/components/SubmissionForm/SubmissionFormMembers');
var SubmissionFormSets = require('submissions/components/SubmissionForm/SubmissionFormSets');
var SubmissionFormTotalSets = require('submissions/components/SubmissionForm/SubmissionFormTotalSets');
var SubmissionFormUploadPoster = require('submissions/components/SubmissionForm/SubmissionFormUploadPoster');
var SubmissionFormUploadPresentation = require('submissions/components/SubmissionForm/SubmissionFormUploadPresentation');
var SubmissionFormUploadClip = require('submissions/components/SubmissionForm/SubmissionFormUploadClip');
var SubmissionFormSubmitterInfo = require('submissions/components/SubmissionForm/SubmissionFormSubmitterInfo');
var SubmissionFormContributors = require('submissions/components/SubmissionForm/SubmissionFormContributors');
var SubmissionFormMaterials = require('submissions/components/SubmissionForm/SubmissionFormMaterials');
var SubmissionFormConfirm = require('submissions/components/SubmissionForm/SubmissionFormConfirm');


module.exports = Base.extend({

    template: template,

    events: {
        'change input[type="radio"]': 'onRadioChange'
    },

    VIEWS_NAMES: [
        'SubmissionFormCategory',
        'SubmissionFormInformationTv',
        'SubmissionFormEpisodes',
        'SubmissionFormInformationFilm',
        'SubmissionFormMembers',
        'SubmissionFormSets',
        'SubmissionFormTotalSets',
        'SubmissionFormUploadPoster',
        'SubmissionFormUploadPresentation',
        'SubmissionFormUploadClip',
        'SubmissionFormSubmitterInfo',
        'SubmissionFormContributors',
        'SubmissionFormMaterials',
        'SubmissionFormConfirm'
    ],

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'SubmissionFormCategory': {selector: '.SubmissionFormCategory', viewConstructor: SubmissionFormCategory},
        'SubmissionFormInformationTv': {selector: '.SubmissionFormInformationTv', viewConstructor: SubmissionFormInformationTv},
        'SubmissionFormEpisodes': {selector: '.SubmissionFormEpisodes', viewConstructor: SubmissionFormEpisodes},
        'SubmissionFormInformationFilm': {selector: '.SubmissionFormInformationFilm', viewConstructor: SubmissionFormInformationFilm},
        'SubmissionFormMembers': {selector: '.SubmissionFormMembers', viewConstructor: SubmissionFormMembers},
        //sets should initiate after episodes
        'SubmissionFormSets': {selector: '.SubmissionFormSets', viewConstructor: SubmissionFormSets},
        'SubmissionFormTotalSets': {selector: '.SubmissionFormTotalSets', viewConstructor: SubmissionFormTotalSets},
        'SubmissionFormUploadPoster': {selector: '.SubmissionFormUploadPoster', viewConstructor: SubmissionFormUploadPoster},
        'SubmissionFormUploadPresentation': {selector: '.SubmissionFormUploadPresentation', viewConstructor: SubmissionFormUploadPresentation},
        'SubmissionFormUploadClip': {selector: '.SubmissionFormUploadClip', viewConstructor: SubmissionFormUploadClip},
        'SubmissionFormSubmitterInfo': {selector: '.SubmissionFormSubmitterInfo', viewConstructor: SubmissionFormSubmitterInfo},
        'SubmissionFormContributors': {selector: '.SubmissionFormContributors', viewConstructor: SubmissionFormContributors},
        'SubmissionFormMaterials': {selector: '.SubmissionFormMaterials', viewConstructor: SubmissionFormMaterials},
        'SubmissionFormConfirm': {selector: '.SubmissionFormConfirm', viewConstructor: SubmissionFormConfirm}
    },


    initialize: function (options) {
        this.options = options || {};


        Base.prototype.initialize.call(this, options);
    },


    onRadioChange: function (e) {
        app.utils.fixSafariRadioRepaint(e);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        this.resetHasChanges();
    },


    hasChanges: function () {
        var currentData = JSON.stringify(this.getFormData());

        return this.previousData != currentData;
    },


    resetHasChanges: function () {
        this.previousData = JSON.stringify(this.getFormData());
    },


    checkRequired: function () {
        for (var i = 0; i < this.VIEWS_NAMES.length; i++) {
            var view = this.getView(this.VIEWS_NAMES[i]);
            if (view) {
                if (!view.checkRequired()) {
                    return false;
                }
            }
        }

        return true;
    },


    getFormData: function () {
        var data = {};

        _.each(this.VIEWS_NAMES, function (viewName) {
            var view = this.getView(viewName);

            if (view) {
                _.extend(data, view.getFormData());
            }
        }.bind(this));

        return data;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionForm.js
// module id = 110
// module chunks = 0